<template>
  <div class="weekly-lesson-notes-section w-100">
    <!-- CONTENT HEADER -->
    <div
      class="content-header d-flex justify-content-start align-items-center nowrap border_grey_dark w-100"
    >
      <div class="section-one">DESCRIPTION</div>
      <div class="section-two">CREATED BY</div>
      <div class="section-three">OPTIONS</div>
    </div>
    <!-- CONTENT HEADER -->

    <!-- CONTENT BODY -->
    <WeeklyLessonNotesRow
      v-for="(data, index) in lesson_data"
      :key="index"
      :id="data.id"
      :title="data.title"
      :extension="data.extension"
      :date="data.date"
      :teacher_name="data.teacher_name"
      :file="data.file"
    />
    <!-- CONTENT BODY -->
  </div>
</template>

<script>
import WeeklyLessonNotesRow from "@/components/schoolComps/dashboard/home/WeeklyLessonNotesRow";
export default {
  name: "WeeklyLessonNotesSection",
  components: {
    WeeklyLessonNotesRow,
  },
  props: {
    lesson_data: Array,
  },
};
</script>

<style lang="scss">
.weekly-lesson-notes-section {
  .content-header {
    padding: 8px;
    padding-left: 10px;
    border-bottom: 1px solid $color_grey_light;
    font-size: 12px;
    line-height: 16px;
    @include breakpoint_max(lg) {
      font-size: 11px;
      padding: 7px;
    }
    .section-one {
      width: 60%;
      @include breakpoint_max(md) {
        width: 70%;
      }
      @include breakpoint_custom_max(430) {
        width: 80%;
      }
    }
    .section-two {
      width: 30%;
      @include breakpoint_max(xs) {
        display: none;
      }
    }
    .section-three {
      width: 12%;
      @include breakpoint_max(md) {
        width: 18%;
      }
      @include breakpoint_max(xs) {
        width: 24%;
      }
    }
  }
}
</style>
